import { uncoveredSalesChannelWarningSchema } from "@redotech/redo-order-common/sales-channels-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getUncoveredSalesChannelWarnings = {
  name: "getUncoveredSalesChannelWarnings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ warnings: z.array(uncoveredSalesChannelWarningSchema) }),
};
